"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.BannerBody = void 0;
require("./BannerBody.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * BannerBody component
 *
 * @method
 * @param {BannerBodyProps} props
 * @returns BannerBody
 */

const BannerBody = props => {
  const {
    body,
    bodyStyle = defaultProps.bodyStyle,
    bulletedList,
    eyebrow,
    headline,
    headlineStyle = defaultProps.headlineStyle,
    headlineTag = defaultProps.headlineTag,
    tag,
    textAlign = defaultProps.textAlign,
    textColor,
    textPosition
  } = props;

  /** Checks if Tag is there */
  const hasTag = tag?.message || tag?.variant === 'urgency';
  const componentClassName = (0, _classnames.default)('pal-c-BannerBody', {
    [`pal-c-BannerBody__textColor--${textColor}`]: textColor,
    [`pal-c-BannerBody__textPosition--${textPosition}`]: textPosition
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasTag && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerBody__tag"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    backgroundColor: tag.backgroundColor,
    boldText: tag.boldText,
    endTime: tag.endTime,
    icon: tag.icon,
    message: tag.message,
    size: tag.size,
    startTime: tag.startTime,
    style: tag.style,
    textColor: tag.textColor,
    theme: tag.theme,
    timerMeta: tag.timerMeta,
    timerType: tag.timerType,
    variant: tag.variant
  })), eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerBody__eyebrow"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    textAlign: textAlign,
    textColor: textColor,
    textStyle: "eyebrow"
  }, eyebrow)), headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerBody__headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: headlineTag,
    textAlign: textAlign,
    textColor: textColor,
    textStyle: headlineStyle
  }, headline)), body && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerBody__body"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "p",
    textAlign: textAlign,
    textColor: textColor,
    textStyle: bodyStyle
  }, body)), bulletedList && /*#__PURE__*/_react.default.createElement("ul", {
    className: "pal-c-BannerBody__bulletedList"
  }, bulletedList.map((listItem, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    textStyle: "body",
    textColor: textColor
  }, listItem)))));
};

/**
 * Property type definitions
 * @typedef BannerBodyProps
 * @type {object}
 * @property {string} body - body text/description of the banner body
 * @property {string} bodyStyle - body text size of the banner body
 * @property {array} bulletedList - array of bulleted list items
 * @property {string} eyebrow - smaller text above the headline
 * @property {string} headline - headline text of the banner body
 * @property {string} headlineStyle - headline font size
 * @property {string} headlineTag - Sets the HTML tag for the container
 * @property {object} tag - tag component above the eyebrow
 * @property {string} textAlign - textAlign for the text
 * @property {string} textColor - text color of the banner body
 * @property {string} textPosition - textPosition for the text
 */
exports.BannerBody = BannerBody;
const propTypes = exports.propTypes = {
  /**
   * body text/description of the banner body
   */
  body: _propTypes.default.string,
  /**
   * body text size of the banner body
   */
  bodyStyle: _propTypes.default.oneOf(['body-xlg', 'body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm']),
  /**
   * array of bulleted list items
   */
  bulletedList: _propTypes.default.array,
  /**
   * smaller text above the headline
   */
  eyebrow: _propTypes.default.string,
  /**
   * headline text of the banner body
   */
  headline: _propTypes.default.string,
  /**
   * headline font size
   */
  headlineStyle: _propTypes.default.oneOf(['body-xlg', 'body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm']),
  /**
   * Sets the HTML tag for the container
   */
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /**
   * Allows passing an object to the tag prop
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tag: _propTypes.default.object,
  /**
   * textAlign for the text
   */
  textAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
  /**
   * textColor for the text
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /**
   * textPosition for the text
   */
  textPosition: _propTypes.default.oneOf(['top-left', 'center-left', 'bottom-left', 'center', 'right'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} bodyStyle - bodyStyle: 'displayBody' - sets the subtitle font size
 * @property {string} headlineStyle - headlineStyle: 'display-lg' - sets the headline font size
 * @property {string} headlineTag - headlineTag: 'h1' - sets the headline tag
 * @property {string} textAlign - textAlign: 'left' - sets the textAlign for the text
 */
const defaultProps = exports.defaultProps = {
  bodyStyle: 'displayBody',
  headlineStyle: 'display-lg',
  headlineTag: 'h2',
  textAlign: 'left'
};
BannerBody.propTypes = propTypes;
var _default = exports.default = BannerBody;